import { Navbar } from './Navbar'
import { Footer } from './Footer'
import { cn } from '@/lib/utils'

type MaxWidth = 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl' | '7xl' | 'full'

interface PageLayoutProps {
  children: React.ReactNode
  /**
   * Inner content max width. Defaults to `4xl` for prose-style pages
   * (Privacy, Terms, About, etc.). Use `7xl` for dense interactive
   * surfaces (the live test demo, API docs) and `full` for full-bleed
   * canvases (Explorer's Scalar embed).
   */
  maxWidth?: MaxWidth
}

const MAX_WIDTH_CLASS: Record<MaxWidth, string> = {
  sm: 'max-w-sm',
  md: 'max-w-md',
  lg: 'max-w-lg',
  xl: 'max-w-xl',
  '2xl': 'max-w-2xl',
  '3xl': 'max-w-3xl',
  '4xl': 'max-w-4xl',
  '5xl': 'max-w-5xl',
  '6xl': 'max-w-6xl',
  '7xl': 'max-w-7xl',
  full: 'max-w-none',
}

export function PageLayout({ children, maxWidth = '4xl' }: PageLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-24 pb-16">
        <div className={cn('mx-auto px-4 sm:px-6 lg:px-8', MAX_WIDTH_CLASS[maxWidth])}>
          {children}
        </div>
      </main>
      <Footer />
    </div>
  )
}
